/**
 * Tutorial guidato dell'elenco Pagine.
 *
 * Il piu' in alto porta dritto alla pagina della nuova pagina, le frecce alla pagina
 * dell'ordinamento. I tre pallini della riga si raccontano illuminando il pulsante,
 * non la voce dentro il menu: aprire un menu di Vuetify dal tutorial non e'
 * affidabile, perche' il click programmatico e quello su "Avanti" arrivano a
 * `document` a un soffio di distanza e il menu appena aperto legge il secondo come
 * un click fuori.
 */
const SCOPE = '[data-tour-scope="pages"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

/** Nessun preparativo: niente da rimettere a posto a fine giro. */
export function stopPagesTour() {}

export function createPagesTourSteps() {
	return [
		{
			body: "Queste sono le pagine di contenuto del sito: chi siamo, contatti, condizioni di vendita, informative. Non sono prodotti ne' categorie - sono testo che vive di suo, con un indirizzo e un posto nei menu.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Le pagine del sito',
		},
		{
			body: "Il piu' in alto porta dritto alla pagina della nuova pagina: li' si scrivono titolo, indirizzo e contenuto per ogni lingua. Annulla riporta qui con l'elenco come l'avevi lasciato. La scheda ha un tutorial suo.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungere una pagina',
		},
		{ body: 'La ricerca filtra per titolo e parte da tre caratteri. Premi Invio o la lente per applicarla.', key: 'search', placement: 'bottom', target: at('search'), title: 'Cercare una pagina' },
		{
			body: "Il filtro restringe l'elenco alle pagine scelte: ogni voce porta il percorso dei padri, per riconoscere le pagine con lo stesso nome. Ricerca, filtro e pagina restano nell'indirizzo: ricaricando o tornando da una scheda li ritrovi.",
			key: 'tools',
			placement: 'bottom',
			target: at('tools'),
			title: 'Filtrare le pagine',
		},
		{
			body: "Le frecce in alto aprono la pagina dell'ordinamento: le pagine si trascinano una sull'altra e si conferma con il pulsante in fondo - e' li' che si decide in che ordine compaiono nei menu del sito.",
			key: 'order',
			placement: 'left',
			target: at('order'),
			title: "L'ordine nei menu",
		},
		{
			body: "Ogni riga e' una pagina: il titolo nella lingua predefinita con sotto l'indirizzo, il tipo - pagina di contenuto o link esterno - i menu in cui compare, la data e l'interruttore.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "L'interruttore pubblica o ritira la pagina, e salva subito. Ritirata non viene cancellata: sparisce dal sito e dai menu, e torna appena lo riaccendi.",
			key: 'switch',
			placement: 'right',
			target: at('switch'),
			title: 'Pubblicare una pagina',
		},
		{
			body: "Il + accanto apre la pagina senza entrarci: l'indirizzo sul sito o il link esterno, in quali menu compare, sotto quale pagina sta, un estratto del testo e come la mostra Google, con l'avviso se mancano meta title o meta description.",
			key: 'expand',
			missing: 'skip',
			placement: 'right',
			target: at('expand'),
			title: 'Vedere la pagina',
		},
		{
			body: "I tre pallini a inizio riga aprono Modifica, che porta alla scheda della pagina, ed Elimina, che chiede conferma. Prima di eliminarne una gia' online vale la pena controllare che non sia linkata da qualche parte: il collegamento resterebbe rotto.",
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Modificare o eliminare',
		},
		{
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere; anche queste restano nell'indirizzo.",
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: "Sfogliare l'elenco",
		},
	];
}
